// tslint:disable
export var PartyExternalIdType;
(function (PartyExternalIdType) {
    // UNKN
    PartyExternalIdType[PartyExternalIdType["UNKNOWN"] = 0] = "UNKNOWN";
    // MBRID
    PartyExternalIdType[PartyExternalIdType["MEMBERID"] = 1] = "MEMBERID";
    // SSN
    PartyExternalIdType[PartyExternalIdType["SOCIALSECURITYNUMBERSSN"] = 2] = "SOCIALSECURITYNUMBERSSN";
    // EIN
    PartyExternalIdType[PartyExternalIdType["FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN"] = 3] = "FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN";
    // DL
    PartyExternalIdType[PartyExternalIdType["DRIVERSLICENSENUMBER"] = 4] = "DRIVERSLICENSENUMBER";
    // DEA
    PartyExternalIdType[PartyExternalIdType["DEANUMBER"] = 5] = "DEANUMBER";
    // NPI
    PartyExternalIdType[PartyExternalIdType["NPINUMBER"] = 6] = "NPINUMBER";
    // GRP
    PartyExternalIdType[PartyExternalIdType["GROUPID"] = 7] = "GROUPID";
    // EMP
    PartyExternalIdType[PartyExternalIdType["EMPLOYEEID"] = 8] = "EMPLOYEEID";
    // STLIC
    PartyExternalIdType[PartyExternalIdType["STATELICENSENUMBER"] = 9] = "STATELICENSENUMBER";
    // PCN
    PartyExternalIdType[PartyExternalIdType["PROCESSORCONTROLLERNUMBER"] = 10] = "PROCESSORCONTROLLERNUMBER";
    // BIN
    PartyExternalIdType[PartyExternalIdType["BANKIDENTIFICATIONNUMBER"] = 11] = "BANKIDENTIFICATIONNUMBER";
    // MEDID
    PartyExternalIdType[PartyExternalIdType["MEDICALID"] = 12] = "MEDICALID";
    // ISGV
    PartyExternalIdType[PartyExternalIdType["ISGOVERNMENT"] = 13] = "ISGOVERNMENT";
    // ARXCN
    PartyExternalIdType[PartyExternalIdType["ASSISTRXCASENUMBER"] = 14] = "ASSISTRXCASENUMBER";
    // ISBENPL
    PartyExternalIdType[PartyExternalIdType["ISMEDICALBENEFIT"] = 15] = "ISMEDICALBENEFIT";
    // COVSTDT
    PartyExternalIdType[PartyExternalIdType["COVERAGESTARTDATE"] = 16] = "COVERAGESTARTDATE";
    // COVENDDT
    PartyExternalIdType[PartyExternalIdType["COVERAGEENDDATE"] = 17] = "COVERAGEENDDATE";
    // PLYR
    PartyExternalIdType[PartyExternalIdType["PLANYEAR"] = 18] = "PLANYEAR";
    // VirmedicaPracId
    PartyExternalIdType[PartyExternalIdType["VirmedicaPraticeID"] = 19] = "VirmedicaPraticeID";
    // VirmedicaLocId
    PartyExternalIdType[PartyExternalIdType["VirmedicaLocationID"] = 20] = "VirmedicaLocationID";
    // VirmedicaPrvdId
    PartyExternalIdType[PartyExternalIdType["VirmedicaProviderID"] = 21] = "VirmedicaProviderID";
    // VirmedicaHCPPrvdId
    PartyExternalIdType[PartyExternalIdType["VirmedicaHCPProviderID"] = 22] = "VirmedicaHCPProviderID";
    // VMMasterPayerID
    PartyExternalIdType[PartyExternalIdType["VirmedicaMasterPayerID"] = 23] = "VirmedicaMasterPayerID";
    // VMPayerID
    PartyExternalIdType[PartyExternalIdType["VirmedicaPayerID"] = 24] = "VirmedicaPayerID";
    // MaxRTEPayorID
    PartyExternalIdType[PartyExternalIdType["MaxRTEPayorID"] = 25] = "MaxRTEPayorID";
    // PTAN
    PartyExternalIdType[PartyExternalIdType["ProviderTransactionAccessNumber"] = 26] = "ProviderTransactionAccessNumber";
})(PartyExternalIdType || (PartyExternalIdType = {}));
PartyExternalIdType['VIRMEDICAPRATICEID'] = 19;
PartyExternalIdType['VIRMEDICALOCATIONID'] = 20;
PartyExternalIdType['VIRMEDICAPROVIDERID'] = 21;
PartyExternalIdType['VIRMEDICAHCPPROVIDERID'] = 22;
PartyExternalIdType['VIRMEDICAMASTERPAYERID'] = 23;
PartyExternalIdType['VIRMEDICAPAYERID'] = 24;
PartyExternalIdType['MAXRTEPAYORID'] = 25;
PartyExternalIdType['PROVIDERTRANSACTIONACCESSNUMBER'] = 26;
//# sourceMappingURL=PartyExternalIdType.js.map